import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TableTemplateColumnConfig } from '@components/ui/table-template/models/table-template-column-config';
import { DataViewModel } from '@components/ui/table-template/models/data-view-model';
import { DataViewModelValue } from '@components/ui/table-template/models/data-view-model-value';
import { DateFormatterService } from '@shared/services/date-formatter.service';

@Component({
    selector: 'app-table-cell-date',
    templateUrl: './table-cell-date.component.html',
    styleUrls: ['./table-cell-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCellDateComponent {
  private readonly dateFormatterService = inject(DateFormatterService);

  public readonly value = signal('');

  initialize(column: TableTemplateColumnConfig, row: DataViewModel, cell: DataViewModelValue): void {
    if (cell instanceof Date) {
      this.value.set(this.dateFormatterService.formatDate(cell));
    }
  }
}
